import React, { useState, useEffect, useMemo } from 'react';
import dayjs from 'dayjs';
import { Box } from '@mui/material';
import Header from './AssetDetailsView/HeaderV2';
import DetailsContent from './AssetDetailsView/DetailsContentV2';
import { useAppSelector } from 'store/hook';
import type { ServiceView } from 'types/survivalAnalysis.types';
import { SingleFadeLoader } from 'components/SingleFadeLoader';
import SquaresDashboardHandler from 'handlers/squaresHandlers/squaresDashboard.handler';

interface Props {
  setShowAssetDetails: any;
  setSelectedAsset: any;
  selectedAsset: ServiceView;
  handleBackClick: () => void;
}

const AssetDetailsView: React.FC<Props> = ({
  setShowAssetDetails,
  setSelectedAsset,
  selectedAsset,
  handleBackClick,
}) => {
  const healthScoreData = useAppSelector(
    (state) => state.squaresDashboardReducer.healthScoreData
  );

  const formattedAndCleanedHealthScoreData = useMemo(() => {
    if (healthScoreData && Object.keys(healthScoreData).length > 0) {
      const assetsArray = Object.values(healthScoreData)
        .map((asset) => ({
          asset_details: asset.asset_details,
          component_details: asset.component_details,
        }))
        .filter((asset) => asset.asset_details?.health_score !== undefined);

      return assetsArray;
    } else {
      console.warn('healthScoreData is empty or invalid.');
      return [];
    }
  }, [healthScoreData]);

  const accessToken = useAppSelector((state) => state.authReducer.accessToken);
  const squaresHandler = new SquaresDashboardHandler();
  const [selectedRange, setSelectedRange] = useState('1Y');
  const [selectedPlan, setSelectedPlan] = useState('All');
  const [selectedView, setSelectedView] = useState('display');
  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    return date;
  });
  const [endDate, setEndDate] = useState(new Date());
  const { isLoading } = useAppSelector(
    (state) => state.squaresPartsRecommendationsReducer
  );

  const handleDateChange = (range: any) => {
    const [startDate, endDate] = range;
    setStartDate(startDate);
    setEndDate(endDate);
  };

  useEffect(() => {
    if (accessToken) {
      void squaresHandler.getPartsRecommendations(startDate, endDate);
    }
  }, [accessToken]);

  return (
    <Box>
      {isLoading ? (
        <>
          <SingleFadeLoader />
        </>
      ) : (
        <>
          <Header
            selectedRange={selectedRange}
            setSelectedRange={setSelectedRange}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            handleDateChange={handleDateChange}
            yesterday={dayjs().subtract(1, 'day').toDate()}
            setShowAssetDetails={setShowAssetDetails}
            setSelectedAsset={setSelectedAsset}
            selectedAsset={selectedAsset}
            healthScores={formattedAndCleanedHealthScoreData}
            handleBackClick={handleBackClick}
          />
          <DetailsContent
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
            selectedView={selectedView}
            setSelectedView={setSelectedView}
            selectedAsset={selectedAsset}
            healthScores={formattedAndCleanedHealthScoreData}
          />
        </>
      )}
    </Box>
  );
};

export default AssetDetailsView;
